import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { ProgramsView } from "@/features/academy/components/programs-view";

export const academyProgramsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/academy/programs",
  component: ProgramsView,
});
